import { useContext } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import AppContext from '../AppContext';
import { CreateFolderInput, CreateOrEditFolderPayload } from './generated/types';

const mutation = `mutation CreateFolder ($input: CreateFolderInput! ) {
        createFolder(input: $input) {
            id
        }
    }`;

export const useCreateFolder = () => {
    const context = useContext(AppContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (params: {
            orgId: string;
            folderName: string;
            parentFolderId?: string;
            editorGroups?: Array<string>;
            readerGroups?: Array<string>;
        }) => {

            const input: CreateFolderInput = {
                name: params.folderName,
                orgId: params.orgId,
                parentFolder: params.parentFolderId,
                editorGroups: params.editorGroups,
                readerGroups: params.readerGroups,
            };

            const response = await (context.api.graphql({
                query: mutation,
                variables: {
                    input,
                },
            }) as Promise<{
                data: {
                    createFolder: CreateOrEditFolderPayload;
                };
            }>);

            return response.data.createFolder.id as string;
        },
        onSuccess: (_, variables) => {
            void queryClient.invalidateQueries({ queryKey: ['listFolders', variables.parentFolderId] });
        },
    });
};